<template>
	<div v-if="city" class="city" id="city" :class="city_color()" v-hammer:pan.vertical="(event)=> pan(event)" v-hammer:panend="(event)=> panend(event)">
		<div class="city-bg" v-hammer:tap="()=> close()"></div>
		<div v-if="!jeuRapideLoading" class="city-content" ref="city">

			<div class="bg">
				<svg data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 326 604"> <g ref="ticket" data-name="Groupe 1375"> <path id="Tracé_36252" data-name="Tracé 36252" fill="currentColor" d="M323.14,39.06h3.12V.27H312.91a18.23,18.23,0,0,1-36.46,0H247.7a18.23,18.23,0,1,1-36.46,0H182.49A18.23,18.23,0,0,1,146,.27H117.28A18.23,18.23,0,0,1,99.05,18.5h0A18.23,18.23,0,0,1,80.82.27H52.06A18.23,18.23,0,0,1,33.83,18.5h0A18.23,18.23,0,0,1,15.6.27H2.26V39.06H5.45a2.39,2.39,0,0,1,2.39,2.38h0a2.39,2.39,0,0,1-2.39,2.39H2.26V466.38H5.45a2.39,2.39,0,0,1,2.39,2.39h0a2.39,2.39,0,0,1-2.39,2.39H2.26V604.27H15.61A18.24,18.24,0,0,1,33.84,586h0a18.24,18.24,0,0,1,18.22,18.23H80.82A18.23,18.23,0,0,1,99,586h0a18.23,18.23,0,0,1,18.23,18.23H146A18.24,18.24,0,0,1,164.25,586h0a18.23,18.23,0,0,1,18.23,18.23h28.75A18.23,18.23,0,0,1,229.47,586h0a18.23,18.23,0,0,1,18.23,18.23h28.76A18.23,18.23,0,0,1,294.68,586h0a18.23,18.23,0,0,1,18.23,18.23h13.35V471.16h-3.12a2.39,2.39,0,0,1-2.39-2.39h0a2.4,2.4,0,0,1,2.39-2.39h3.12V43.84h-3.12a2.39,2.39,0,0,1-2.39-2.39h0A2.39,2.39,0,0,1,323.14,39.06ZM29.45,468.77a2.39,2.39,0,0,1-2.39,2.39H20.59a2.39,2.39,0,0,1-2.39-2.39h0a2.39,2.39,0,0,1,2.39-2.39h6.47A2.39,2.39,0,0,1,29.45,468.77ZM27.06,43.84H20.59a2.39,2.39,0,0,1,0-4.78h6.47a2.39,2.39,0,0,1,2.39,2.39h0A2.39,2.39,0,0,1,27.06,43.84Zm24,424.93a2.39,2.39,0,0,1-2.39,2.39H42.2a2.39,2.39,0,0,1-2.38-2.39h0a2.38,2.38,0,0,1,2.38-2.39h6.47a2.39,2.39,0,0,1,2.39,2.39ZM48.67,43.84H42.2a2.39,2.39,0,0,1,0-4.78h6.47a2.39,2.39,0,0,1,2.39,2.38h0a2.39,2.39,0,0,1-2.39,2.39Zm24,424.93a2.39,2.39,0,0,1-2.39,2.39H63.81a2.39,2.39,0,0,1-2.38-2.39h0a2.39,2.39,0,0,1,2.38-2.39h6.47A2.39,2.39,0,0,1,72.67,468.77ZM70.28,43.84H63.81a2.39,2.39,0,0,1,0-4.78h6.47a2.39,2.39,0,0,1,2.39,2.39h0a2.39,2.39,0,0,1-2.39,2.39Zm24,424.93a2.39,2.39,0,0,1-2.39,2.39H85.43A2.39,2.39,0,0,1,83,468.77h0a2.39,2.39,0,0,1,2.39-2.39h6.46a2.39,2.39,0,0,1,2.39,2.39ZM91.89,43.84H85.43a2.39,2.39,0,0,1,0-4.78h6.46a2.39,2.39,0,0,1,2.39,2.38h0a2.39,2.39,0,0,1-2.39,2.39Zm24,424.93a2.39,2.39,0,0,1-2.38,2.39H107a2.39,2.39,0,0,1-2.39-2.39h0a2.4,2.4,0,0,1,2.39-2.39h6.47A2.39,2.39,0,0,1,115.89,468.77ZM113.51,43.84H107a2.39,2.39,0,0,1,0-4.78h6.47a2.39,2.39,0,0,1,2.38,2.39h0a2.39,2.39,0,0,1-2.39,2.39h0Zm24,424.93a2.39,2.39,0,0,1-2.39,2.39h-6.47a2.39,2.39,0,0,1-2.39-2.39h0a2.39,2.39,0,0,1,2.39-2.39h6.47a2.4,2.4,0,0,1,2.39,2.39ZM135.12,43.84h-6.47a2.39,2.39,0,0,1,0-4.78h6.47a2.39,2.39,0,0,1,2.39,2.38h0a2.39,2.39,0,0,1-2.39,2.39h0Zm24,424.93a2.39,2.39,0,0,1-2.39,2.39h-6.47a2.39,2.39,0,0,1-2.39-2.39h0a2.4,2.4,0,0,1,2.39-2.39h6.47A2.39,2.39,0,0,1,159.12,468.77ZM156.73,43.84h-6.47a2.39,2.39,0,1,1,0-4.78h6.47a2.39,2.39,0,0,1,2.39,2.39h0a2.39,2.39,0,0,1-2.39,2.39h0Zm24,424.93a2.39,2.39,0,0,1-2.39,2.39h-6.48a2.39,2.39,0,0,1-2.39-2.39h0a2.39,2.39,0,0,1,2.39-2.39h6.47a2.39,2.39,0,0,1,2.39,2.39h0ZM178.34,43.84h-6.48a2.39,2.39,0,0,1,0-4.78h6.47a2.39,2.39,0,0,1,2.39,2.38h0a2.4,2.4,0,0,1-2.39,2.39Zm24,424.93a2.39,2.39,0,0,1-2.39,2.39h-6.47a2.39,2.39,0,0,1-2.39-2.39h0a2.4,2.4,0,0,1,2.39-2.39H200A2.39,2.39,0,0,1,202.34,468.77ZM200,43.84h-6.47a2.39,2.39,0,1,1,0-4.78H200a2.39,2.39,0,0,1,2.39,2.39h0A2.39,2.39,0,0,1,200,43.84h0Zm24,424.93a2.39,2.39,0,0,1-2.39,2.39h-6.47a2.39,2.39,0,0,1-2.39-2.39h0a2.39,2.39,0,0,1,2.39-2.39h6.47a2.39,2.39,0,0,1,2.39,2.39ZM221.56,43.84h-6.47a2.39,2.39,0,0,1,0-4.78h6.47A2.39,2.39,0,0,1,224,41.45h0a2.39,2.39,0,0,1-2.39,2.39h0Zm24,424.93a2.39,2.39,0,0,1-2.39,2.39h-6.48a2.39,2.39,0,0,1-2.39-2.39h0a2.4,2.4,0,0,1,2.39-2.39h6.47a2.39,2.39,0,0,1,2.39,2.39Zm-2.4-424.93h-6.47a2.39,2.39,0,1,1,0-4.78h6.47a2.39,2.39,0,0,1,2.39,2.39h0A2.39,2.39,0,0,1,243.16,43.84Zm24,424.93a2.39,2.39,0,0,1-2.39,2.39H258.3a2.39,2.39,0,0,1-2.38-2.39h0a2.39,2.39,0,0,1,2.38-2.39h6.47a2.39,2.39,0,0,1,2.39,2.39ZM264.77,43.84H258.3a2.39,2.39,0,0,1,0-4.78h6.47a2.39,2.39,0,0,1,2.39,2.39h0a2.4,2.4,0,0,1-2.38,2.39Zm24,424.93a2.39,2.39,0,0,1-2.39,2.39h-6.46a2.39,2.39,0,0,1-2.39-2.39h0a2.39,2.39,0,0,1,2.38-2.39h6.47A2.39,2.39,0,0,1,288.77,468.77ZM286.38,43.84h-6.46a2.39,2.39,0,0,1,0-4.78h6.47a2.39,2.39,0,0,1,2.39,2.39h0a2.39,2.39,0,0,1-2.38,2.39Zm24,424.93a2.38,2.38,0,0,1-2.38,2.39h-6.47a2.39,2.39,0,0,1-2.39-2.39h0a2.39,2.39,0,0,1,2.39-2.39H308a2.38,2.38,0,0,1,2.38,2.39ZM308,43.84h-6.47a2.39,2.39,0,1,1,0-4.78H308a2.38,2.38,0,0,1,2.38,2.39h0A2.38,2.38,0,0,1,308,43.84Z"/> <g id="Groupe_1374" data-name="Groupe 1374"> <path id="Tracé_36253" data-name="Tracé 36253" fill="#fff" d="M308,43.84h-6.47a2.4,2.4,0,0,1-2.36-2.07H288.74a2.39,2.39,0,0,1-2.35,2.07h-6.47a2.4,2.4,0,0,1-2.36-2.07H267.13a2.39,2.39,0,0,1-2.35,2.07h-6.47A2.4,2.4,0,0,1,256,41.77H245.52a2.4,2.4,0,0,1-2.36,2.07h-6.47a2.39,2.39,0,0,1-2.35-2.07H223.91a2.4,2.4,0,0,1-2.36,2.07h-6.47a2.39,2.39,0,0,1-2.35-2.07H202.3a2.4,2.4,0,0,1-2.36,2.07h-6.47a2.39,2.39,0,0,1-2.35-2.07H180.69a2.4,2.4,0,0,1-2.36,2.07h-6.47a2.39,2.39,0,0,1-2.35-2.07H159.08a2.4,2.4,0,0,1-2.36,2.07h-6.47a2.38,2.38,0,0,1-2.35-2.07H137.46a2.39,2.39,0,0,1-2.35,2.07h-6.47a2.4,2.4,0,0,1-2.36-2.07H115.86a2.39,2.39,0,0,1-2.35,2.07H107a2.4,2.4,0,0,1-2.36-2.07H94.25a2.4,2.4,0,0,1-2.36,2.07H85.43a2.4,2.4,0,0,1-2.36-2.07H72.64a2.4,2.4,0,0,1-2.36,2.07H63.82a2.4,2.4,0,0,1-2.36-2.07H51a2.4,2.4,0,0,1-2.36,2.07H42.21a2.4,2.4,0,0,1-2.36-2.07H29.42a2.4,2.4,0,0,1-2.36,2.07H20.59a2.39,2.39,0,0,1-2.35-2.07H7.81a2.4,2.4,0,0,1-2.36,2.07H2.26V466.38H5.45a2.39,2.39,0,0,1,2.39,2.39H18.21a2.39,2.39,0,0,1,2.38-2.39h6.47a2.39,2.39,0,0,1,2.39,2.39H39.82a2.39,2.39,0,0,1,2.39-2.39h6.46a2.39,2.39,0,0,1,2.39,2.39H61.43a2.39,2.39,0,0,1,2.38-2.39h6.47a2.39,2.39,0,0,1,2.39,2.39H83a2.39,2.39,0,0,1,2.39-2.39h6.46a2.39,2.39,0,0,1,2.39,2.39h10.37a2.39,2.39,0,0,1,2.39-2.39h6.47a2.38,2.38,0,0,1,2.38,2.39h10.37a2.39,2.39,0,0,1,2.39-2.39h6.47a2.39,2.39,0,0,1,2.38,2.39h10.36a2.39,2.39,0,0,1,2.39-2.39h6.47a2.39,2.39,0,0,1,2.39,2.39h10.36a2.39,2.39,0,0,1,2.39-2.39h6.47a2.39,2.39,0,0,1,2.39,2.39h10.36a2.39,2.39,0,0,1,2.39-2.39h6.47a2.39,2.39,0,0,1,2.39,2.39h10.36a2.39,2.39,0,0,1,2.39-2.39h6.47a2.39,2.39,0,0,1,2.39,2.39H234.3a2.39,2.39,0,0,1,2.39-2.39h6.47a2.39,2.39,0,0,1,2.39,2.39h10.36a2.39,2.39,0,0,1,2.39-2.39h6.47a2.39,2.39,0,0,1,2.39,2.39h10.37a2.39,2.39,0,0,1,2.38-2.39h6.47a2.39,2.39,0,0,1,2.39,2.39h10.37a2.39,2.39,0,0,1,2.39-2.39H308a2.39,2.39,0,0,1,2.39,2.39h10.37a2.39,2.39,0,0,1,2.38-2.39h3.13V43.84h-3.12a2.4,2.4,0,0,1-2.36-2.07H310.35A2.39,2.39,0,0,1,308,43.84Z"/> </g> </g> </svg>
			</div>

			<div class="content" :style="{ width: width + 'px', height: height + 'px' }">

				<div v-if="notEnoughPointsMessage" class="ticket-message">
					<div class="need-points">
						<div>VOUS AVEZ BESOIN DE</div>
						<div class="points">{{ criteria }} <ui-icon :tags="[ 'resource', 'lys', 'grey' ]" :size="28" /></div>
						<div>POUR VOYAGER VERS</div>
					</div>
					<div class="name" :class="city_color()">{{ getValueOnPath(city, 'document.title') || '' }}</div>
					<div class="button" :class="city_color()" v-hammer:tap="()=> closeMessage()">
						<div>OK</div>
					</div>
				</div>

				<template v-else>

					<div class="name">{{ getValueOnPath(city, 'document.title') || '' }}</div>
					<div class="stamp">
						<city-badge :city="city" :unlocked="is_unlocked"/>
						<transition name="unlocked-badge">
							<city-badge :city="city" :unlocked="is_unlocked" />
						</transition>
						<div v-if="is_unlocked && trivia_game_tuto" class="opponent" :class="{ loading }" v-hammer:tap="launch_city_tuto" v-html="opponent_avatar"></div>
					</div>

					<div class="city-step step-travel" v-if="!is_unlocked">
						<div class="city-step-content" v-if="city.clientGames.length">
							<div class="main-button" v-hammer:tap="()=> travel()">
								<div>Voyager</div>
								<div>{{ criteria }} <ui-icon :tags="[ 'resource', 'lys', 'white' ]" :size="18" /></div>
							</div>
						</div>
						<div class="city-step-content" v-else>
							Aucun jeu disponible pour cette ville.
						</div>
					</div>

					<transition-group v-if="is_unlocked" name="game-button" tag="div" class="city-step step-games" appear>
						<game-button v-for="game in city.clientGames" :game="game" :color="city.document.color" :city="city" :key="game.id" />
					</transition-group>

					<div class="city-step step-win" v-if="false">
						<div class="city-step-content">
							<div class="main-text">
								<p>Félicitations!</p>
								<p>Vous avez gagné</p>
								<p>350 <ui-icon :tags="[ 'resource', 'lys', 'gray' ]" :size="18" /></p>
							</div>

							<div class="main-button big-height" v-hammer:tap="()=> get_reward()">Récolter</div>
						</div>
					</div>

				</template>


				<div class="bottom">
					<div class="logo">
						<span class="text">ROUTES<br>OQLF</span>
						<span class="bus"></span>
					</div>
					<div class="barcode"></div>
				</div>

				<div class="close" v-if="!is_win" v-hammer:tap="()=> close()"></div>

			</div>
		</div>

		<div v-else class="jeu-rapide-loading">
			<div class="loading"></div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import CityBadge from '@/components/world/city-badge'
import GameButton from '@/components/world/game-button'
import { getValueOnPath} from "../../js/utils/utils"
import {getPointsByCity} from "../../js/utils/achievements"
import {manageEventListeners} from "@/js/managers/manageEventListeners"

export default {
	name: 'city',
	data() {
		return {
			loading: false,
			jeuRapideLoading: false,
			width: 0,
			height: 0,
			notEnoughPointsMessage: false,
			manageEventListeners: manageEventListeners()
		}
	},
	props: {
		city: { default: null }
	},
	computed: {
		...mapGetters([ 'app', 'user', 'user_gold' ]),
		fleurDeLys() {
			const tags = [ 'resource', 'lys', 'grey' ]
			return this.$medias.find({ tags })
		},
		opponent_avatar() {
			const tags = [ this.city.slug, 'avatar' ]
			return this.$medias.find({ tags })
		},
		closable() {
			return !this.is_win
		},
		criteria() {
			const { city: { clientCriterias }} = this
			return getPointsByCity({ clientCriterias })
		},
		is_unlocked() {
			if (!this.city.clientCriterias.length) return true
			let criteria = this.city.clientCriterias.find((c) => { return c.action == 'spend' && c.clientLootItem && c.clientLootItem.countable  && c.clientLootItem.slug == 'gold' })
			if (criteria && this.user.achievement.criteriasAchieved.find((achieve) => { return achieve.criteriaId == criteria.id })) return true
			return false
		},
		unlockable() {
			let criteria = this.city.clientCriterias.find((c) => { return c.clientLootItem.slug == 'gold' })
			return this.user_gold >= criteria.amount
		},
		is_win() {
			return false
		},
		trivia_game_tuto() {
			if (this.user.achievement && this.user.achievement.tutorialJournal) {
				return this.user.achievement.tutorialJournal.find((t) => t.tutorialId === 'trivia_game')
			}
			return false
		}
	},
	methods: {
		getValueOnPath,
		city_color() {
			return (this.city.document && this.city.document.color) ? this.city.document.color : ''
		},
		launch_city_tuto() {
			if (!this.loading) {
				this.loading = true
				if (this.city.clientGames.length) {
					let tuto = this.user.achievement.tutorialJournal.find((t) => t.tutorialId === 'trivia_game')
					if (tuto) {
						this.$store.commit('EDIT_TUTORIAL_JOURNAL', { tuto, status: 'not-done' })
						this.$router.push({ name: 'game', params: { city_slug: this.city.slug, game_id: this.city.clientGames[0].id } })
					}
				}
			}
		},
		travel() {
			if (!this.is_unlocked && this.unlockable) {
				this.$store.dispatch('unlock_city', { city: this.city })

				// Lancemenent tuto
				const tuto_name = this.city.slug.replaceAll('-', '_').replaceAll(' ', '_')
				const user_tuto = this.user.achievement.tutorialJournal.find((j) => j.tutorialId === tuto_name)
				if (!user_tuto || user_tuto.status !== 'done') {
					setTimeout(() => {
						const animations = this.$medias.findAllByTags({ tags: [ 'character_animation', this.city.slug ] })
						this.$store.commit('EDIT_APP_STATE', { tuto: { name: tuto_name, animations } })
					}, 500)
				}

				return
			}
			if (!this.is_unlocked) {
				this.$data.notEnoughPointsMessage = true
			}
		},
		has_gold_medal(game) {
			let criteria = game.clientCriterias.find((c) => {
				return c.action == 'presence' && this.user.achievement.criteriasAchieved.find((achieved) => { return achieved.criteriaId == c.id })
			})
			if (criteria) return true
			return false
		},
		get_reward() {
			this.$store.dispatch('get_user')
		},
		closeMessage() {
			this.$data.notEnoughPointsMessage = false
		},
		close() {
			if (this.closable) {
				this.$router.push({ name: 'world' })
			}
		},
		pan(e) {
			if (this.closable) {
				let target = this.$refs.city
				let y = e.deltaY
				if (y > 0) y = 0
				target.style.transform = 'translate(0, ' + y + 'px)'
			}
		},
		panend(e) {
			if (this.closable) {
				let target = this.$refs.city
				let y = e.deltaY

				target.classList.add('panning')

				if (y < 0 && Math.abs(y) > target.clientHeight / 5) {
					target.style.transform = 'translate(0, -150%)'
					// target.style.opacity = 0
					this.close()
				} else  {
					// target.style.opacity = 1
					target.style.transform = 'translate(0, 0)'
				}

				setTimeout(() => {
					target.classList.remove('panning')
					target.style.transform = ''
				}, 250)
			}
		},
		resize() {
			if (this.$refs.ticket) {
				const rect = this.$refs.ticket.getBoundingClientRect()
				if (rect) {
					this.width = Math.round(rect.width)
					this.height = Math.round(rect.height)
				}
			}
		}
	},
	mounted() {
		this.manageEventListeners.add(window, 'resize', this.resize)
		this.resize()
	},
	created() {
		if (!localStorage.getItem('jeuRapide')) {
			// Lancemenent tuto gatineau
			const user_tuto = this.user.achievement.tutorialJournal.find((j) => j.tutorialId === this.city.slug)
			if (this.city && this.city.slug === 'gatineau' && (!user_tuto || user_tuto.status !== 'done')) {
				const animations = this.$medias.findAllByTags({ tags: [ 'character_animation', this.city.slug ] })
				this.$store.commit('EDIT_APP_STATE', { tuto: { name: this.city.slug, animations } })
			}
		} else
			this.jeuRapideLoading = true
	},
	components: { CityBadge, GameButton },
	beforeDestroy() {
		this.manageEventListeners.destroy()
	}
}
</script>

<style lang="stylus" scoped>
@import '../../assets/css/variables'
@import '../../assets/css/city_color'


#app.mobile
	.city .city-content
		padding 18% 0 44% 0


.city
	&.city-enter-active, &.city-leave-active
		transition 0.25s easeOutQuart
		.city-content
			transition 0.25s easeOutQuart
	&.city-enter, &.city-leave-to
		opacity 0
		.city-content
			transform translateY(-40px)
	// &.city-leave-to
	// 	opacity 0
	// 	.city-content
	// 		transform translateY(40px)

.game-button
	transition 0.25s easeOutQuart
	&:nth-child(1)
		transition-delay 0.1s
		>>> .medal
			transition-delay 0.5s !important
	&:nth-child(2)
		transition-delay 0.2s
		>>> .medal
			transition-delay 0.6s !important
	&:nth-child(3)
		transition-delay 0.3s
		>>> .medal
			transition-delay 0.7s !important
	&:nth-child(4)
		transition-delay 0.4s
		>>> .medal
			transition-delay 0.8s !important
	// &.game-button-active, &.game-button-leave-active
	// 	transition 0.25s easeOutQuart
	&.game-button-enter, &.game-button-leave-to
		opacity 0
		transform translateY(50%)
		>>> .medal
			opacity 0
			transform scale(3) !important

.city
	position absolute
	left 0
	top 0
	right 0
	bottom 0
	height 100%
	width 100%
	display flex
	align-items center
	justify-content center
	&.tuto-highlight
		.city-bg
			display none
	.city-bg
		position absolute
		left 0
		top 0
		right 0
		bottom 0
		background-color alpha(#000, 15%)
	.jeu-rapide-loading
		position absolute
		left 0
		top 0
		right 0
		bottom 0
		background alpha(#000, 50%) url(../../assets/img/button-loader.svg) center center no-repeat
		background-size 80px
		cursor wait

	.city-content
		width calc(100% - 40px)
		height calc(100% - 40px)
		max-width (326px * 1.3)
		max-height (604px * 1.3)
		// background-color alpha(red, 25%)
		flex center center
		// padding 7% 0 17% 0
		&.panning
			transition transform 0.25s easeOutQuart

		.bg
			absolute 0
			>>> svg
				width 100%
				height 100%
		.content
			position absolute
			width 100%
			top 50%
			transform translate(0, -50%)
			padding 15% 0 45% 0
			flex center center
			flex-direction column
			// background-color alpha(red, 50%)

			.ticket-message
				top 10px
				height 350px
				display flex
				align-items center
				justify-content space-around
				align-content center
				flex-direction column
				.button
					display flex
					justify-content center
					align-items center
					color #fff
					width calc(100% - 64px)
					height 55px
					padding 10px 20px 10px 20px
					font-size 1.3em
					border-radius 10px
					box-shadow 0px 6px 6px alpha(#000, 30%)
					text-transform uppercase
					cursor pointer
				.name
					margin 0 0 16px 0
					padding 0 4px
					font-size 3.7rem
					font-weight 700
					text-transform uppercase
					text-align center
					line-height 32px
				.need-points
					display flex
					flex-direction column
					align-items center
					color #949292
					font-size 1.5em
					font-weight 700
					line-height 45px
					.points
						font-size 1.2em

			.name
				margin 0 0 16px 0
				padding 0 4px
				font-size 3.7rem
				font-weight 700
				color #1CB5E0
				text-transform uppercase
				text-align center
				line-height 32px

			.stamp
				width 100%
				height 250px
				flex center center
				margin 0 0 32px 0
				>>> .city-badge
					position absolute
					left calc(50% - 125px)
					top 0
					width 250px
					height 250px
					background-color #fff
					&.unlocked-badge-enter-active, &.unlocked-badge-leave-active
						transition 0.5s easeInQuart
					&.unlocked-badge-enter, &.unlocked-badge-leave-to
						opacity 0
						transform scale(4) rotate(-15deg)
				.opponent
					position absolute
					right 10%
					top 10%
					width 64px
					height 64px
					border-radius 50%
					cursor pointer
					animation opponent-avatar 1.5s linear infinite
					>>> svg
						width 100%
						height 100%
					&.loading
						cursor progress
						&:after
							content ''
							absolute 0
							background alpha(dark, 75%) url('../../assets/img/button-loader.svg') center center no-repeat
							background-size 32px
							border-radius 50%
			.city-step
				width 100%
				flex center center
				&.step-win
					.city-step-content
						margin-bottom 0
						transform translateY(-16px)
						.main-text
							margin-bottom 8px
				.city-step-content
					width 100%
					// margin-bottom 100px
					text-align center
					.main-button
						width calc(100% - 64px)
						background-color dark
						margin 0 32px
						padding 8px 0
						box-shadow 0px 6px 6px alpha(#000, 30%)
						border-radius 8px
						cursor pointer
						text-align center
						font-size 2.4rem
						font-weight 500
						text-transform uppercase
						color #fff
						&.big-height
							padding 16px 0
						&:hover
							background-color darken(dark, 10%)
						&:active
							background-color darken(dark, 10%)
							transform translateY(2px)
							box-shadow 0px 4px 4px alpha(#000, 30%)
						&.locked
							cursor not-allowed
							background-color #c6c6c6
							box-shadow inset 0 2px 2px #bbb
							&:hover, &:active
								transform none
								box-shadow inset 0 2px 2px #bbb
								background-color #c6c6c6
						> div
							display flex
							align-items center
							justify-content center
							.ui-icon
								margin 0 0 0 8px
					.not-enough-gold
						margin 16px 0 0 0
						padding 0 32px
						color red
						font-weight 700
						text-transform uppercase
						font-size 1.4rem
						line-height 16px
					.main-text
						color #949292
						font-size 2.4rem
						text-align center
						line-height 28px
						text-transform uppercase
		.bottom
			position absolute
			left 0
			right 0
			bottom 16px
			height 120px
			display flex
			align-items center
			justify-content center
			flex-direction column
			.logo
				flex center center
				height 24px
				margin 0 0 8px 0
				line-height 12px
				text-align right
				color #fff
				font-size 1.4rem
				font-weight 700
				.bus
					width 48px
					height 24px
					margin 0 0 0 4px
					background url(../../assets/img/little-bus.svg) center center no-repeat
					background-size auto 100%
			.barcode
				width 100%
				height 40%
				background url(../../assets/img/barcode.svg) center center no-repeat
				background-size auto 100%

		.close
			position absolute
			right -8px
			top -8px
			width 40px
			height 40px
			background dark_blue url(../../assets/img/close.svg) center center no-repeat
			background-size 16px auto
			border-radius 50%
			border 4px solid #fff
			cursor pointer
			box-shadow 0 0 4px alpha(#000, 25%)
			&:active
				transform translateY(1px)

@media (max-height: 760px)
	.city .city-content
		.content
			.stamp
				height 212px
				.city-badge
					height 212px
					width 212px
					left calc(50% - 106px)

@keyframes opponent-avatar
	0%, 100%
		transform scale(1)
	50%
		transform scale(1.1)


</style>
